import React, {useState, useEffect} from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Divider,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography
} from "@mui/material";
import {Navigate} from "react-router-dom";
import User from "../backend/User";
import AdminData from "../backend/dataservices/AdminData";

function AdminSelectPage() {
    const [roles, setRoles] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedTenant, setSelectedTenant] = useState('');
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [navigateTo, setNavigateTo] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        Promise.all([
            AdminData.getRoles(),
            AdminData.getTenants()
        ]).then(([rolesData, tenantsData]) => {
            if (Array.isArray(rolesData)) setRoles(rolesData);
            if (Array.isArray(tenantsData)) setTenants(tenantsData);
            setLoading(false);
        }).catch(() => {
            setError('Daten konnten nicht geladen werden.');
            setLoading(false);
        });
    }, []);

    const handleContinue = () => {
        if (!selectedRole || !selectedTenant) return;
        setSubmitting(true);
        setError(null);
        AdminData.assumeRole(selectedRole, selectedTenant).then((response) => {
            User.saveToken(response.token);
            User.decodeToken(response.token);
            setNavigateTo(User.getHomepage());
        }).catch(() => {
            setError('Fehler beim Anwenden der Auswahl.');
            setSubmitting(false);
        });
    };

    const handleLogout = () => {
        User.logout();
        window.location = process.env.PUBLIC_URL + "/login";
    };

    if (navigateTo) {
        return <Navigate to={navigateTo} replace/>;
    }

    return (
        <div style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
        }}>
            <Card sx={{maxWidth: 480, minWidth: 360}}>
                <CardHeader
                    title={"WebTrain"}
                    subheader={"Administration"}
                    style={{backgroundColor: "rgb(0,150,136)", color: 'white'}}
                    subheaderTypographyProps={{color: 'rgba(255,255,255,0.8)'}}
                />
                <CardContent sx={{py: 3}}>
                    <Typography variant="body1" color="text.secondary" sx={{mb: 3}}>
                        Wählen Sie eine Rolle und einen Tenant, um die Anwendung zu nutzen,
                        oder wechseln Sie direkt zur Administration.
                    </Typography>

                    {loading ? (
                        <Box sx={{display: 'flex', justifyContent: 'center', my: 4}}>
                            <CircularProgress/>
                        </Box>
                    ) : (
                        <>
                            <FormControl fullWidth sx={{mb: 2}}>
                                <InputLabel>Rolle</InputLabel>
                                <Select
                                    value={selectedRole}
                                    label="Rolle"
                                    onChange={(e) => setSelectedRole(e.target.value)}
                                >
                                    {roles.map(role => (
                                        <MenuItem key={role.name} value={role.name}>{role.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl fullWidth sx={{mb: 2}}>
                                <InputLabel>Tenant</InputLabel>
                                <Select
                                    value={selectedTenant}
                                    label="Tenant"
                                    onChange={(e) => setSelectedTenant(e.target.value)}
                                >
                                    {tenants.map(t => (
                                        <MenuItem key={t.T_ID} value={t.T_ID}>
                                            {t.T_Name} ({t.T_Code})
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {error && (
                                <Typography color="error" variant="body2" sx={{mb: 2}}>
                                    {error}
                                </Typography>
                            )}

                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={handleContinue}
                                disabled={!selectedRole || !selectedTenant || submitting}
                                sx={{mb: 2}}
                            >
                                {submitting ? <CircularProgress size={24} color="inherit"/> : 'Weiter'}
                            </Button>

                            <Divider sx={{my: 2}}>oder</Divider>

                            <Button
                                variant="outlined"
                                color="primary"
                                fullWidth
                                onClick={() => setNavigateTo('/admin/users')}
                                sx={{mb: 2}}
                            >
                                Zur Administration
                            </Button>

                            <Button
                                variant="text"
                                fullWidth
                                onClick={handleLogout}
                                sx={{color: 'text.secondary'}}
                            >
                                Abmelden
                            </Button>
                        </>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}

export default AdminSelectPage;
